import React from 'react';

import { smoothScroll } from '../../app/ui';
import CallMeForm from '../../components/ForRestaurants/CallMeForm';
import SavingsCalculator from '../../components/SavingsCalculators/SavingsCalculator.tsx';
import OnlineOrdersBenefits from '../../components/ForRestaurants/OnlineOrdersBenefits';
import PartnerLogos from '../../components/ForRestaurants/PartnerLogos';
import SpecialOfferTimer from '../../components/ForRestaurants/SpecialOfferTimer';
import RestaurateurFaq from '../../components/ForRestaurants/RestaurateurFaq';
import { getSafeUrlParam } from 'Utils/url-params';
import { createDerivedStateFromErrorLogger } from 'Utils/log';

class ForRestaurantsSpecialOffer extends React.Component {

  state = {};

  componentDidMount() {
    document.querySelector('.until-react-spinner').remove();
    smoothScroll();
    const restaurantName = getSafeUrlParam('rn');
    restaurantName && this.setState({ restaurantName: restaurantName.split('-').join(' ') });
  }

  render() {
    return <>
      <section className="for-restaurants-intro">
        <h1 className="fr-title">Oferta ratunkowa dla restauracji</h1>
        {this.state.restaurantName && <div className="mb-3">Oferta OtoStolik dla restauracji <span className="capitalize">{this.state.restaurantName}</span></div>}
        <h2 className="fr-subtitle">Uruchom zamówienia online <span className="text-primary">za darmo do końca 2020 roku</span> - zacznij zarabiać już teraz</h2>
        <a href="#join-today" className="js-scroll-trigger for-restaurants-cta-btn">Dołącz teraz</a>
        <SpecialOfferTimer />
      </section>
      <div className="container mb-4">
        <section className="for-restaurants-why pb-3">
          <h2 className="fr-title">Dlaczego OtoStolik?</h2>
          <OnlineOrdersBenefits />
          <h2 className="fr-title">Ile możesz zaoszczędzić?</h2>
          <SavingsCalculator />
        </section>
      </div>
      <CallMeForm
        id="join-today"
        title="Dołącz do grona naszych partnerów"
        text="Podaj numer telefonu - oddzwonimy w ciągu godziny!"
      />
      <PartnerLogos />
      <section className="for-restaurants-how text-left">
        <h4 className="home-title home-title--smaller">Wciąż masz pytania?</h4>
        <RestaurateurFaq />
      </section>
      <CallMeForm
        id="call-me"
        title="Czy możemy Ci w czymś jeszcze pomóc?"
        text="Podaj numer telefonu - oddzwonimy w ciągu godziny!"
      />
    </>;
  }
}

ForRestaurantsSpecialOffer.getDerivedStateFromError = createDerivedStateFromErrorLogger('ForRestaurantsSpecialOffer');

export default ForRestaurantsSpecialOffer;
